import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {I18nService} from "./service/i18nService";

const LanguageSetter = () => {
    const i18nService = new I18nService();
    let lang = i18nService.getLanguage();
    const {i18n} = useTranslation();

    if (!['de', 'en'].includes(lang)) {
        lang = 'en';
    }
    useEffect(() => {
        if (lang && ['en', 'de'].includes(lang)) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return null;
};

export default LanguageSetter;
